module.exports = __webpack_public_path__ + "img/logo-mq-white.fc0f76d9.png";